import * as React from "react";
const SvgStatusFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 2, cy: 3, r: 5, transform: "translate(9 9)", fill: "currentColor" }));
export default SvgStatusFilled;
